import "../css/lws.scss";

require("./scripts.js");
// require("slick-carousel");
